import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import api from "../Utility/api";
import { useAuth } from "../Utility/AuthContext";
import StoryCard from "../Components/StoryCard";
import Seo from "../Components/Seo";
const API = process.env.REACT_APP_API_URL || "";
export default function Dashboard() {
  const { user } = useAuth();
  const [stories, setStories] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState("");
  const [sort, setSort] = useState("popular");
  useEffect(() => {
    let active = true;
    api
      .get(`${API}/api/stories`)
      .then(({ data }) => {
        if (active) setStories(data);
      })
      .catch(() => {
        if (active)
          setError("The library could not be loaded. Please try again.");
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);
  const filtered = stories
    .filter((story) =>
      `${story.story_name} ${story.story_desc} ${story.author}`
        .toLowerCase()
        .includes(query.toLowerCase()),
    )
    .sort((a, b) =>
      sort === "newest" ? b.id - a.id : b.number_of_likes - a.number_of_likes,
    );
  return (
    <Container maxWidth="lg" sx={{ pt: { xs: 4, md: 7 } }}>
      <Seo title="Explore choose your own adventure stories" />
      <span className="eyebrow">The community library</span>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        gap={3}
        mb={4}
      >
        <Box>
          <Typography variant="h2" component="h1">
            Find a path of your own.
          </Typography>
          <Typography color="text.secondary" mt={1}>
            Step into a new world. See where your choices take you.
          </Typography>
        </Box>
        <Box sx={{ alignSelf: "center" }}>
          <Button
            component={Link}
            to={user ? "/create" : "/register"}
            variant="contained"
          >
            + Write a story
          </Button>
        </Box>
      </Stack>
      <Stack direction={{ xs: "column", sm: "row" }} gap={2} mb={4}>
        <TextField
          label="Search stories or authors"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          size="small"
          sx={{ flex: 1 }}
        />
        <TextField
          select
          label="Sort by"
          value={sort}
          onChange={(event) => setSort(event.target.value)}
          size="small"
          sx={{ minWidth: 170 }}
        >
          <MenuItem value="popular">Most loved</MenuItem>
          <MenuItem value="newest">Newest first</MenuItem>
        </TextField>
      </Stack>
      {error && <Alert severity="error">{error}</Alert>}
      {loading ? (
        <Box textAlign="center" p={8}>
          <CircularProgress aria-label="Loading stories" />
        </Box>
      ) : filtered.length ? (
        <div className="library-grid">
          {filtered.map((story, index) => (
            <StoryCard
              key={story.id}
              story={story}
              index={index}
              owner={user?.id === story.created_by}
            />
          ))}
        </div>
      ) : (
        !error && (
          <div className="empty-state">
            <Typography variant="h5">
              {query
                ? "No stories match that search."
                : "The next great adventure could be yours."}
            </Typography>
            <Typography color="text.secondary" my={2}>
              {query
                ? "Try another title or author."
                : "Be the first to fill these shelves."}
            </Typography>
            <Button component={Link} to={user ? "/create" : "/register"}>
              Start writing →
            </Button>
          </div>
        )
      )}
    </Container>
  );
}
